import { render, staticRenderFns } from "./parts-locations-printing-card.vue?vue&type=template&id=331c47bf&scoped=true&"
import script from "./parts-locations-printing-card.vue?vue&type=script&lang=js&"
export * from "./parts-locations-printing-card.vue?vue&type=script&lang=js&"
import style0 from "./parts-locations-printing-card.vue?vue&type=style&index=0&id=331c47bf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "331c47bf",
  null
  
)

export default component.exports